import React from 'react'
import { InlineWidget } from "react-calendly";

function BookingModal() {
  return (
    <div>
      <InlineWidget url="https://calendly.com/joshua_blockapps" />
    </div>
  )
}

export default BookingModal